"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const utilities_1 = require("../../utilities");
const AsyncSelect_1 = tslib_1.__importDefault(require("../../AsyncSelect"));
const TheSelect_1 = tslib_1.__importDefault(require("../../TheSelect"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const Wrapper = styled_components_1.default.div ``;
const C = (_a) => {
    var { onAdd, getSmarttagsKeys, getSmarttagsValues, getSmarttagsByFts, availableSmarttags = [], placeholder = '', readOnly = false, creatable = true, disabled = false } = _a, restProps = tslib_1.__rest(_a, ["onAdd", "getSmarttagsKeys", "getSmarttagsValues", "getSmarttagsByFts", "availableSmarttags", "placeholder", "readOnly", "creatable", "disabled"]);
    const [key, setKey] = React.useState('');
    const [value, setValue] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');
    const getItemLabel = (item) => {
        const { title } = item;
        if (item.key && item.value) {
            return `${item.key}:${item.value}`;
        }
        else if (title && title !== '') {
            return title;
        }
        else if (item.value) {
            return item.value;
        }
        return item.key;
    };
    const getItems = (availableSmarttags) => {
        if (key) {
            const smarttagName = availableSmarttags.find((smarttag) => smarttag.key === key);
            if (smarttagName) {
                const values = smarttagName.values.reduce((prev, smarttag) => {
                    if (smarttag.key
                        .toLocaleLowerCase()
                        .indexOf(inputValue.toLocaleLowerCase()) >= 0 ||
                        (smarttag.title &&
                            smarttag.title
                                .toLocaleLowerCase()
                                .indexOf(inputValue.toLocaleLowerCase()) >= 0)) {
                        return [...prev, smarttag];
                    }
                    return prev;
                }, []);
                return values;
            }
            return [];
        }
        return availableSmarttags.reduce((prev, smarttag) => {
            if (smarttag.key
                .toLocaleLowerCase()
                .indexOf(inputValue.toLocaleLowerCase()) >= 0 ||
                (smarttag.title &&
                    smarttag.title
                        .toLocaleLowerCase()
                        .indexOf(inputValue.toLocaleLowerCase()) >= 0)) {
                return [...prev, smarttag];
            }
            return prev;
        }, []);
    };
    const handleChangeValue = (newValue) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setInputValue(newValue);
        if (key) {
            setValue(newValue);
        }
        else if (creatable && newValue[newValue.length - 1] === ':') {
            const [newKey] = newValue.split(':');
            setKey(newKey);
            setInputValue('');
        }
    });
    const handleSelectItem = (item) => {
        if (readOnly) {
            return false;
        }
        if (!item && !creatable) {
            return false;
        }
        if (item === null) {
            if (typeof value !== 'undefined' && value.length > 0) {
                onAdd({
                    key: key.trim(),
                    values: [{ key: value.trim() }],
                });
                setValue('');
                return true;
            }
            return false;
        }
        if (item.key && item.value) {
            onAdd({
                key: item.key,
                values: [{ key: item.value }],
            });
            setKey('');
            setValue('');
            setInputValue('');
            return true;
        }
        else if (key) {
            onAdd({
                key,
                values: [{ key: item ? item.key || item.value : value }],
            });
            setKey('');
            setValue('');
            setInputValue('');
            return true;
        }
        setKey(`${item.key || item.value}`);
        setInputValue('');
        return false;
    };
    let currentGetFunc = getSmarttagsKeys;
    if (key && getSmarttagsValues) {
        currentGetFunc = () => getSmarttagsValues(key, inputValue);
    }
    else if (!key && inputValue && getSmarttagsByFts) {
        currentGetFunc = () => getSmarttagsByFts(inputValue);
    }
    return (React.createElement(Wrapper, null, getSmarttagsKeys && getSmarttagsValues ? (React.createElement(AsyncSelect_1.default, Object.assign({ value: null, createNewOptionLabel: !key ? (0, utilities_1.__)('Vytvoriť nový smart') : (0, utilities_1.__)('Vytvoriť nový tag'), placeholder: placeholder }, (creatable && {
        createNewOption: val => {
            return {
                label: val,
                value: val,
            };
        },
    }), { tags: key ? [{ label: key, value: key }] : [], onChangeTags: () => {
            setValue('');
            setKey('');
        }, onChangeInput: handleChangeValue, inputValue: inputValue, setInputValue: setInputValue, onChange: handleSelectItem, renderLabel: getItemLabel, loadOptions: currentGetFunc, loadDefaultOptions: currentGetFunc, onBlur: ref => {
            if (ref && ref.current && key && !value) {
                setTimeout(() => {
                    ref.current.focus();
                });
            }
        }, "data-testid": "InputSmarttag-Input" }, restProps))) : (React.createElement(TheSelect_1.default, Object.assign({ value: null, createNewOptionLabel: !key ? (0, utilities_1.__)('Vytvoriť nový smart') : (0, utilities_1.__)('Vytvoriť nový tag'), filterOptions: null, placeholder: placeholder }, (creatable && {
        createNewOption: val => {
            return {
                label: val,
                value: val,
            };
        },
    }), { tags: key ? [{ label: key, value: key }] : [], onChangeTags: () => {
            setKey('');
            setValue('');
        }, inputValue: inputValue, setInputValue: setInputValue, onChangeInput: handleChangeValue, renderLabel: getItemLabel, options: getItems(availableSmarttags), onChange: handleSelectItem, disabled: disabled, "data-testid": "InputSmarttag-Input", onBlur: ref => {
            if (ref && ref.current && key && !value) {
                setTimeout(() => {
                    ref.current.focus();
                });
            }
        } }, restProps)))));
};
exports.default = C;
